// src/pages/personal/settings/PromotionsDiscountsPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import PromotionsDiscountsSection from './PromotionsDiscountsSection/PromotionsDiscountsSection';

const PromotionsDiscountsPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <PromotionsDiscountsSection />
    </AdaptiveLayout>
  );
};

export default PromotionsDiscountsPage;